// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Filters_Filters__o-303 {
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.Filters_Filters__o-303 .Filters_rightZone__yX8sE {
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/tables/components/DocumentProcessing/TargetShowcase/Filters/Filters.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,mBAAA;AAAF;AAEE;EACE,aAAA;EACA,SAAA;AAAJ","sourcesContent":[".Filters {\n  width: 100%;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  //padding: 16px 24px;\n  margin-bottom: 16px;\n\n  .rightZone {\n    display: flex;\n    gap: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Filters": `Filters_Filters__o-303`,
	"rightZone": `Filters_rightZone__yX8sE`
};
export default ___CSS_LOADER_EXPORT___;
